import React from 'react';
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Ashridge Park FC</title>
        <meta name="description" content="Privacy Policy for Ashridge Park Football Club website." />
      </Helmet>
      
      <Container className="p-3 my-4">
        <h1 className="mb-4">Privacy Policy</h1>
        
        <h3>Cookie Usage</h3>
        <p>
          This website uses Google Analytics to help us understand how visitors use our site. 
          These cookies collect information in an anonymous form, including the number of visitors, 
          where visitors come from, and the pages they visit.
        </p>
        
        <h3>Sponsor Discount Vouchers</h3>
        <p>
          If you use our members' discount page to generate a voucher for one of our
          sponsors, we record the name you entered, the date and time, and a one-way
          hashed version of your IP address. We do not store your IP address itself,
          though a hashed address is still information that relates to you.
        </p>
        <p>
          We do this to prevent misuse of a discount offered to us in good faith, and to
          tell the sponsor how often the offer is being used. Any figures we share with a
          sponsor are totals only &mdash; we never pass on individual names. A small number
          of club officials can view these records. We keep these
          records for 13 months and then delete them. Our lawful basis is our legitimate
          interest in protecting the club's relationship with its sponsors.
        </p>

        <h3>Contact Information</h3>
        <p>
          If you have any questions about our privacy policy or cookie usage, 
          please contact us using our contact form.
        </p>
      </Container>
    </>
  );
};

export default PrivacyPolicy;